import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import asyncComponent from "../../../util/asyncComponent";

const ChurnPrevention = ({ match }) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const hasAccess = authUser && authUser.Claims.includes("admin.access");

  return (
    <div className="app-wrapper">
      <Switch>
        {hasAccess && (
          <Redirect
            exact
            from={`${match.url}/`}
            to={`${match.url}/possible-departures`}
          />
        )}
        {hasAccess && (
          <Redirect exact from={match.url} to={`${match.url}/possible-departures`} />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/possible-departures`}
            component={asyncComponent(() => import("./routes/PossibleDepartures"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/hanging-invest-divests`}
            component={asyncComponent(() => import("./routes/HangingInvestDivests"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/poor-accuracy`}
            component={asyncComponent(() => import("./routes/PoorAccuracy"))}
          />
        )}
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default ChurnPrevention;
